import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import ITask from '@/core/Models/ITask';
import Status, { StatusTitle } from '../core/Values/Status';


export default /*@__PURE__*/_defineComponent({
  __name: 'VTaskStatus',
  props: {
    task: { type: Object as PropType<ITask>, required: true },
    showTitle: { type: Boolean, default: true },
    subStatusTitle: { type: String, default: '' },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();

const statusColorClassName = {
    [Status.Draft]: 'status--blurry',
    [Status.Approvement]: 'status--orange',
    [Status.InProgress]: 'status--positive',
    [Status.Completed]: 'status--orange',
    [Status.Rejected]: 'status--blurry',
    [Status.Finished]: 'status--green',
};

const statusTitle = computed((): string => {
    if (!props.showTitle) {
        return '';
    }

    if (props.task.archivedAt) {
        return t('statuses.archived');
    }

    if (props.task.status === Status.Draft && props.task.inProgressAt) {
        return t('statuses.draft-in-progress');
    }

    if (props.task.status === Status.Approvement && props.task.inProgressAt) {
        return t('statuses.re-approvement');
    }

    const statusTitleKey = StatusTitle[props.task.status as keyof typeof StatusTitle] as string;

    return t(statusTitleKey ?? 'unknown');
});

const className = computed((): string => {
    if (props.task.archivedAt) {
        return 'status--negative';
    }

    return statusColorClassName[props.task.status as keyof typeof statusColorClassName] ?? '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["status status--indicator", className.value])
  }, _toDisplayString(statusTitle.value), 3))
}
}

})